var autotab = function (current, next) {
    if (
        current.getAttribute &&
        current.value.length == current.getAttribute("maxlength")
    ) {
        next.focus();
    }
};

$(document).ready(function () {
    $(".nav-list a").each(function (i) {
        var href = $(this).attr("href");
        href = href.replace(/(#.*|\?.*)/, "");
        var re = new RegExp(location.pathname + "index.(php|html)", "i");
        if (href === location.pathname || re.test(href)) {
            $(this).parents("li").addClass("active");
        }
    });

    $(".skip").click(function (event) {
        var skipTo = "#" + this.href.split("#")[1];
        $(skipTo)
            .attr("tabindex", -1)
            .on("blur focusout", function () {
                $(this).removeAttr("tabindex");
            })
            .focus();
    });

    var resizeHandler = function (e) {
        var windowWidth = $(window).width();
        var $swappableImage = $("#swappable-image");
        var $swappableImage2 = $("#swappable-image2");
        var $mobileTicketmoney = $("#mobile-ticket-money-shim");
        if (windowWidth >= 768) {
            $swappableImage.attr("src", $swappableImage.data("alt-src"));
            $swappableImage2.attr("src", $swappableImage2.data("alt-src"));
            $mobileTicketmoney.html("");
        } else {
            $swappableImage.attr("src", $swappableImage.data("alt-small"));
            $swappableImage2.attr("src", $swappableImage2.data("alt-small"));
            $mobileTicketmoney.html(
                '<img class="center-block img-responsive" src="/vegaschallenge2023/assets/images/sub-page-bg.png" alt="Image of $5 MILLION VEGAS CHALLENGE tickets." />'
            );
        }
    };

    resizeHandler();
    // then on load assign that function to the resize event
    window.addEventListener("resize", resizeHandler);
});

document.addEventListener(
    "DOMContentLoaded",
    function () {
        if (/Android/i.test(navigator.userAgent)) {
            changePdfHref(document.getElementsByTagName("a"));
            changePdfHref(document.getElementsByTagName("area"));
        }

        function changePdfHref(items) {
            var reg = /\.pdf/;

            for (var i = 0, j = items.length; i < j; i++) {
                href = items[i].getAttribute("href");

                if (reg.test(href)) {
                    items[i].setAttribute(
                        "href",
                        encodeURI("http://docs.google.com/viewer?url=" + href)
                    );
                }
            }
        }
    },
    false
);
